export default "__VITE_ASSET__DT5A42Z2__"